import { render } from "./Page3Component.vue?vue&type=template&id=a59e530a"
import script from "./Page3Component.vue?vue&type=script&lang=js"
export * from "./Page3Component.vue?vue&type=script&lang=js"

import "./Page3Component.vue?vue&type=style&index=0&id=a59e530a&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__